import styled from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'
import { StyledH1, StyledParagraph } from '../text/styles'

export const StyledTextWrapper = styled.div`
  position: relative;
  color: ${themeStyles.colors.white.main};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5em;
  padding: 2em 0 0;
  min-height: 4em;
  box-sizing: border-box;

  ${StyledH1}, ${StyledParagraph} {
    text-align: center;
    max-width: 700px;
  }

  ${StyledH1} {
    max-width: 70vw;
  }

  ${themeMedia.maxDesktop`
    padding: 0.8em 0 0;

    a {
      top: 0.7em;
    }
  `}
`
